import React from "react";
import ReactDOM from "react-dom";
import {
  Trail,
  Keyframes,
  animated,
  config,
  Transition,
} from "react-spring/renderprops";
import "./App.css";

// words images
import amasa from "../../assets/images/words/amasa.png";
import naranja from "../../assets/images/words/naranja.png";
import balde from "../../assets/images/words/balde.png";
import volcán from "../../assets/images/words/volcán.png";
import olla from "../../assets/images/words/olla.png";
import vaso from "../../assets/images/words/vaso.png";
import silla from "../../assets/images/words/silla.png";
import falda from "../../assets/images/words/falda.png";
import delfín from "../../assets/images/words/delfín.png";
import familia from "../../assets/images/words/familia.png";
import fantasma from "../../assets/images/words/fantasma.png";
import fiesta from "../../assets/images/words/fiesta.png";
import fideos from "../../assets/images/words/fideos.png";
import flauta from "../../assets/images/words/flauta.png";
import foto from "../../assets/images/words/foto.png";
import ala from "../../assets/images/words/ala.png";
import arbol from "../../assets/images/words/arbol.png";
import avión from "../../assets/images/words/avión.png";
import apio from "../../assets/images/words/apio.png";
import cama from "../../assets/images/words/cama.png";
import come_torta from "../../assets/images/words/come_torta.png";
import corazón from "../../assets/images/words/corazón.png";
import hombre from "../../assets/images/words/hombre.png";
import lápiz from "../../assets/images/words/lápiz.png";
import lee from "../../assets/images/words/lee.png";
import león from "../../assets/images/words/león.png";
import lila from "../../assets/images/words/lila.png";
import lima from "../../assets/images/words/lima.png";
import limón from "../../assets/images/words/limón.png";
import lobo from "../../assets/images/words/lobo.png";
import loma from "../../assets/images/words/loma.png";
import loro from "../../assets/images/words/loro.png";
import luna from "../../assets/images/words/luna.png";
import mamá from "../../assets/images/words/mamá.png";
import manos from "../../assets/images/words/manos.png";
import melón from "../../assets/images/words/melón.png";
import mesa from "../../assets/images/words/mesa.png";
import mapa from "../../assets/images/words/mapa.png";
import miel from "../../assets/images/words/miel.png";
import mimo from "../../assets/images/words/mimo.png";
import momia from "../../assets/images/words/momia.png";
import mono from "../../assets/images/words/mono.png";
import moto from "../../assets/images/words/moto.png";
import muela from "../../assets/images/words/muela.png";
import mula from "../../assets/images/words/mula.png";
import ola from "../../assets/images/words/ola.png";
import oso from "../../assets/images/words/oso.png";
import patinar from "../../assets/images/words/patinar.png";
import perro from "../../assets/images/words/perro.png";
import piña from "../../assets/images/words/piña.png";
import rosa from "../../assets/images/words/rosa.png";
import sol from "../../assets/images/words/sol.png";
import sala from "../../assets/images/words/sala.png";
import sal from "../../assets/images/words/sal.png";  
import seis from "../../assets/images/words/seis.png";
import suma from "../../assets/images/words/suma.png";  
import tortuga from "../../assets/images/words/tortuga.png";
import isla from "../../assets/images/words/isla.png";
import bicicleta from "../../assets/images/words/bicicleta.png";
import chancho from "../../assets/images/words/chancho.png";
import dado from "../../assets/images/words/dado.png";
import dedo from "../../assets/images/words/dedo.png";
import elefante from "../../assets/images/words/elefante.png";
import erizo from "../../assets/images/words/erizo.png";
import escalera from "../../assets/images/words/escalera.png";
import escoba from "../../assets/images/words/escoba.png";
import lupa from "../../assets/images/words/lupa.png";
import nido from "../../assets/images/words/nido.png";
import nudo from "../../assets/images/words/nudo.png";
import pala from "../../assets/images/words/pala.png";
import pan from "../../assets/images/words/pan.png";
import pera from "../../assets/images/words/pera.png";
import paloma from "../../assets/images/words/paloma.png";
import pipa from "../../assets/images/words/pipa.png";
import puma from "../../assets/images/words/puma.png";
import pulpo from "../../assets/images/words/pulpo.png";
import sombrero from "../../assets/images/words/sombrero.png";
import sopa from "../../assets/images/words/sopa.png";
import guitarra from "../../assets/images/words/guitarra.png";
import papa from "../../assets/images/words/papa.png";
import pila from "../../assets/images/words/pila.png";
import jirafa from "../../assets/images/words/jirafa.png";
import pez from "../../assets/images/words/pez.png";
import torta from "../../assets/images/words/torta.png";
import queque from "../../assets/images/words/queque.png";
import duende from "../../assets/images/words/duende.png";
import maleta from "../../assets/images/words/maleta.png";
import manta from "../../assets/images/words/manta.png";
import nota from "../../assets/images/words/nota.png";
import pasto from "../../assets/images/words/pasto.png";
import patines from "../../assets/images/words/patines.png";
import pato from "../../assets/images/words/pato.png";
import pelota from "../../assets/images/words/pelota.png";
import pepino from "../../assets/images/words/pepino.png";
import pino from "../../assets/images/words/pino.png";
import tapa from "../../assets/images/words/tapa.png";
import tomate from "../../assets/images/words/tomate.png";
import topo from "../../assets/images/words/topo.png";
import tuna from "../../assets/images/words/tuna.png";
import manzana from "../../assets/images/words/manzana.png";
import sapo from "../../assets/images/words/sapo.png";
import abeja from "../../assets/images/words/abeja.png";
import araña from "../../assets/images/words/araña.png";
import ardilla from "../../assets/images/words/ardilla.png";
import calcetín from "../../assets/images/words/calcetín.png";
import camión from "../../assets/images/words/camión.png";
import camisa from "../../assets/images/words/camisa.png";
import caracol from "../../assets/images/words/caracol.png";
import casa from "../../assets/images/words/casa.png";
import corbata from "../../assets/images/words/corbata.png";
import estrella from "../../assets/images/words/estrella.png";
import gato from "../../assets/images/words/gato.png";
import zapatilla from "../../assets/images/words/zapatilla.png";
import dama from "../../assets/images/words/dama.png";
import dos from "../../assets/images/words/dos.png";
import duda from "../../assets/images/words/duda.png";
import espada from "../../assets/images/words/espada.png";
import lodo from "../../assets/images/words/lodo.png";
import ludo from "../../assets/images/words/ludo.png";
import pelado from "../../assets/images/words/pelado.png";
import pudú from "../../assets/images/words/pudú.png";
import soldado from "../../assets/images/words/soldado.png";
import conejo from "../../assets/images/words/conejo.png";
import rana from "../../assets/images/words/rana.png";
import sandía from "../../assets/images/words/sandía.png";
import lana from "../../assets/images/words/lana.png";
import piano from "../../assets/images/words/piano.png";
import murciélago from "../../assets/images/words/murciélago.png";
import queso from "../../assets/images/words/queso.png";
import teléfono from "../../assets/images/words/teléfono.png";
import quitasol from "../../assets/images/words/quitasol.png";
import vaca from "../../assets/images/words/vaca.png";
import sofá from "../../assets/images/words/sofá.png";
import torre from "../../assets/images/words/torre.png";
import tierra from "../../assets/images/words/tierra.png";
import tarro from "../../assets/images/words/tarro.png";
import rueda from "../../assets/images/words/rueda.png";
import rosado from "../../assets/images/words/rosado.png";
import risa from "../../assets/images/words/risa.png";
import río from "../../assets/images/words/río.png";
import reno from "../../assets/images/words/reno.png";
import remo from "../../assets/images/words/remo.png";
import reina from "../../assets/images/words/reina.png";
import ratón from "../../assets/images/words/ratón.png";
import rama from "../../assets/images/words/rama.png";
import uva from "../../assets/images/words/uva.png";
import ula from "../../assets/images/words/ula-ula.png";
import tres from "../../assets/images/words/tres.png";
import pantalón from "../../assets/images/words/pantalón.png";
import toro from "../../assets/images/words/toro.png";
import tesoro from "../../assets/images/words/tesoro.png";
import sirena from "../../assets/images/words/sirena.png";
import serpiente from "../../assets/images/words/serpiente.png";
import dinero from "../../assets/images/words/dinero.png";
import dinosaurio from "../../assets/images/words/dinosaurio.png";
import flor from "../../assets/images/words/flor.png";
import mariposa from "../../assets/images/words/mariposa.png";
import pirata from "../../assets/images/words/pirata.png";
import campanas from "../../assets/images/words/campanas.png";
import esqueleto from "../../assets/images/words/esqueleto.png";
import foca from "../../assets/images/words/foca.png";
import galleta from "../../assets/images/words/galleta.png";
import helado from "../../assets/images/words/helado.png";
import hormiga from "../../assets/images/words/hormiga.png";
import huevo from "../../assets/images/words/huevo.png";
import peces from "../../assets/images/words/peces.png";
import nueces from "../../assets/images/words/nueces.png";
import lápices from "../../assets/images/words/lápices.png";
import edificios from "../../assets/images/words/edificios.png";
import dulce from "../../assets/images/words/dulce.png";
import doce from "../../assets/images/words/doce.png";
import cocina from "../../assets/images/words/cocina.png";
import cisne from "../../assets/images/words/cisne.png";
import ciruela from "../../assets/images/words/ciruela.png";
import circo from "../../assets/images/words/circo.png";
import cinturón from "../../assets/images/words/cinturón.png";
import cinta from "../../assets/images/words/cinta.png";
import cinco from "../../assets/images/words/cinco.png";
import cerro from "../../assets/images/words/cerro.png";
import candado from "../../assets/images/words/candado.png";
import ajo from "../../assets/images/words/ajo.png";
import bañera from "../../assets/images/words/bañera.png";
import bote from "../../assets/images/words/bote.png";
import buho from "../../assets/images/words/buho.png";
import burro from "../../assets/images/words/burro.png";
import choclo from "../../assets/images/words/choclo.png";
import gelatina from "../../assets/images/words/gelatina.png";
import girasol from "../../assets/images/words/girasol.png";
import jaula from "../../assets/images/words/jaula.png";
import hilo from "../../assets/images/words/hilo.png";
import hongo from "../../assets/images/words/hongo.png";
import jugo from "../../assets/images/words/jugo.png";
import kiwi from "../../assets/images/words/kiwi.png";
import leche from "../../assets/images/words/leche.png";
import pimentón from "../../assets/images/words/pimentón.png";
import hueso from "../../assets/images/words/hueso.png";
import vestido from "../../assets/images/words/vestido.png";
import raqueta from "../../assets/images/words/raqueta.png";
import quiosco from "../../assets/images/words/quiosco.png";
import paquete from "../../assets/images/words/paquete.png";
import quince from "../../assets/images/words/quince.png";
import parque from "../../assets/images/words/parque.png";
import mosquito from "../../assets/images/words/mosquito.png";
import maniquí from "../../assets/images/words/maniquí.png";
import esquimal from "../../assets/images/words/esquimal.png";
import bosque from "../../assets/images/words/bosque.png";
import unicornio from "../../assets/images/words/unicornio.png";
import cometa from "../../assets/images/words/cometa.png";
import gusano from "../../assets/images/words/gusano.png";
import regalo from "../../assets/images/words/regalo.png";
import manguera from "../../assets/images/words/manguera.png";
import guinda from "../../assets/images/words/guinda.png";
import guerrero from "../../assets/images/words/guerrero.png";
import guepardo from "../../assets/images/words/guepardo.png";
import gitana from "../../assets/images/words/gitana.png";
import gimnasta from "../../assets/images/words/gimnasta.png";
import gigante from "../../assets/images/words/gigante.png";
import gente from "../../assets/images/words/gente.png";
import genio from "../../assets/images/words/genio.png";
import gemelos from "../../assets/images/words/gemelos.png";
import ángel from "../../assets/images/words/ángel.png";
import águila from "../../assets/images/words/águila.png";
import colegio from "../../assets/images/words/colegio.png";
import chaleco from "../../assets/images/words/chaleco.png";
import flores from "../../assets/images/words/flores.png";
import chocolate from "../../assets/images/words/chocolate.png";
import koala from "../../assets/images/words/koala.png";
import lechuga from "../../assets/images/words/lechuga.png";
import gata from "../../assets/images/words/gata.png";
import tijera from "../../assets/images/words/tijera.png";
import reloj from "../../assets/images/words/reloj.png";
import lentejas from "../../assets/images/words/lentejas.png";
import juego from "../../assets/images/words/juego.png";
import jeringa from "../../assets/images/words/jeringa.png";
import jardinero from "../../assets/images/words/Jardinero.png";
import jardín from "../../assets/images/words/jardín.png";
import jamón from "../../assets/images/words/jamón.png";
import jaguar from "../../assets/images/words/jaguar.png";
import guante from "../../assets/images/words/guante.png";
import caja from "../../assets/images/words/caja.png";
import hipopótamo from "../../assets/images/words/hipopótamo.png";
import ave from "../../assets/images/words/ave.png";
import oveja from "../../assets/images/words/oveja.png";
import pavo_real from "../../assets/images/words/pavo real.png";
import vela from "../../assets/images/words/vela.png";
import ventana from "../../assets/images/words/ventana.png";
import vienesa from "../../assets/images/words/vienesa.png";
import hiena from "../../assets/images/words/hiena.png";
import gorila from "../../assets/images/words/gorila.png";
import hada from "../../assets/images/words/hada.png";
import tiburón from "../../assets/images/words/tiburón.png";
import abuela from "../../assets/images/words/abuela.png";
import castillo from "../../assets/images/words/castillo.png";
import cebra from "../../assets/images/words/cebra.png";
import autobús from "../../assets/images/words/autobús.png";
import pantuflas from "../../assets/images/words/pantuflas.png";
import princesa from "../../assets/images/words/princesa.png";
import taxi from "../../assets/images/words/taxi.png";
import saxofón from "../../assets/images/words/saxofón.png";
import sandwich from "../../assets/images/words/sandwich.png";
import zapato from "../../assets/images/words/zapato.png";
import ballena from "../../assets/images/words/ballena.png";
import caballo from "../../assets/images/words/caballo.png";
import cebolla from "../../assets/images/words/cebolla.png";
import gallina from "../../assets/images/words/gallina.png";
import grillo from "../../assets/images/words/grillo.png";
import llama from "../../assets/images/words/llama.png";
import llave from "../../assets/images/words/llave.png";
import ocho from "../../assets/images/words/ocho.png";
import tigre from "../../assets/images/words/tigre.png";



const dict_words = {
  hiena: hiena,
  ballena: ballena,
  caballo: caballo,
  cebolla: cebolla,
  gallina: gallina,
  grillo: grillo,
  llama: llama,
  tigre: tigre,
  ocho: ocho,
  llave: llave,
  zapato: zapato,
  sandwich: sandwich,
  saxofón: saxofón,
  pantuflas: pantuflas,
  princesa: princesa,
  taxi: taxi,
  toro: toro,
  gorila: gorila,
  hada: hada,
  tiburón: tiburón,
  abuela: abuela,
  castillo: castillo,
  cebra: cebra,
  autobús: autobús,
  ventana: ventana,
  vienesa: vienesa,
  ave: ave,
  oveja: oveja,
  'pavo real': pavo_real,
  vela: vela,
  tijera: tijera,
  reloj: reloj,
  lentejas: lentejas,
  juego: juego,
  jeringa: jeringa,
  jardinero: jardinero,
  jardín: jardín,
  jamón: jamón,
  jaguar: jaguar,
  guante: guante,
  caja: caja,
  hipopótamo: hipopótamo,
  gata: gata,
  gimnasta: gimnasta,
  chaleco: chaleco,
  flores: flores,
  chocolate: chocolate,
  koala: koala,
  lechuga: lechuga,
  colegio: colegio,
  águila: águila,
  gigante: gigante,
  gente: gente,
  genio: genio,
  gemelos: gemelos,
  ángel: ángel,
  regalo: regalo,
  manguera: manguera,
  guinda: guinda,
  guerrero: guerrero,
  guepardo: guepardo,
  gitana: gitana,
  gusano: gusano,
  unicornio: unicornio,
  raqueta: raqueta,
  cometa: cometa,
  quiosco: quiosco,
  paquete: paquete,
  quince: quince,
  parque: parque,
  mosquito: mosquito,
  maniquí: maniquí,
  esquimal: esquimal,
  bosque: bosque,
  vestido: vestido,
  hueso: hueso,
  cerro: cerro,
  candado: candado,
  cinco: cinco,
  cinta: cinta,
  ajo: ajo,
  bañera: bañera,
  bote: bote,
  buho: buho,
  burro: burro,
  choclo: choclo,
  gelatina: gelatina,
  girasol: girasol,
  jaula: jaula,
  hilo: hilo,
  hongo: hongo,
  peces: peces,
  nueces: nueces,
  lápices: lápices,
  edificios: edificios,
  cocina: cocina,
  cinturón: cinturón,
  dulce: dulce,
  doce: doce,
  ciruela: ciruela,
  circo: circo,
  cisne: cisne,
  pimentón: pimentón,
  leche: leche,
  kiwi: kiwi,
  jugo: jugo,
  hormiga: hormiga,
  tesoro: tesoro,
  huevo: huevo,
  sirena: sirena,
  serpiente: serpiente,
  dinero: dinero,
  dinosaurio: dinosaurio,
  flor: flor,
  mariposa: mariposa,
  pirata: pirata,
  campanas: campanas,
  esqueleto: esqueleto,
  foca: foca,
  galleta: galleta,
  helado: helado,
  rana: rana,
  torre: torre,
  tierra: tierra,
  tarro: tarro,
  rueda: rueda,
  rosado: rosado,
  risa: risa,
  río: río,
  reno: reno,
  remo: remo,
  reina: reina,
  ratón: ratón,
  rama: rama,
  uva: uva,
  'ula-ula': ula,
  tres: tres,
  pantalón: pantalón,
  naranja: naranja,
  balde: balde,
  volcán: volcán,
  olla: olla,
  vaso: vaso,
  silla: silla,
  delfín: delfín,
  familia: familia,
  sofá: sofá,
  foto: foto,
  fantasma: fantasma,
  fiesta: fiesta,
  fideos: fideos,
  flauta: flauta,
  vaca: vaca,
  quitasol: quitasol,
  falda: falda,
  teléfono: teléfono,
  queso: queso,
  murciélago: murciélago,
  piano: piano,
  sandía: sandía,
  lana: lana,
  apio: apio,
  conejo: conejo,
  dama: dama,
  dos: dos,
  duda: duda,
  espada: espada,
  lodo: lodo,
  ludo: ludo,
  pelado: pelado,
  pudú: pudú,
  soldado: soldado,
  paloma: paloma,
  pipa: pipa,
  puma: puma,
  papa: papa,
  pila: pila,
  zapatilla: zapatilla,
  mapa: mapa,
  dedo: dedo,
  escalera: escalera,
  escoba: escoba,
  lupa: lupa,
  nido: nido,
  nudo: nudo,
  pan: pan,
  elefante: elefante,
  erizo: erizo,
  amasa: amasa,
  pala: pala,
  pera: pera,
  pulpo: pulpo,
  sombrero: sombrero,
  sopa: sopa,
  isla: isla,
  ala: ala,
  árbol: arbol,
  avión: avión,
  bicicleta: bicicleta,
  cama: cama,
  chancho: chancho,
  come_torta: come_torta,
  corazón: corazón,
  dado: dado,
  guitarra: guitarra,
  hombre: hombre,
  jirafa: jirafa,
  lápiz: lápiz,
  lee: lee,
  sapo: sapo,
  león: león,
  lila: lila,
  lima: lima,
  limón: limón,
  lobo: lobo,
  loma: loma,
  loro: loro,
  luna: luna,
  mamá: mamá,
  manos: manos,
  manzana: manzana,
  melón: melón,
  mesa: mesa,
  miel: miel,
  mimo: mimo,
  momia: momia,
  mono: mono,
  moto: moto,
  mula: mula,
  muela: muela,
  manta: manta,
  ola: ola,
  oso: oso,
  patinar: patinar,
  perro: perro,
  pez: pez,
  piña: piña,
  rosa: rosa,
  sol: sol,
  seis: seis,
  sal: sal,
  sala: sala,
  suma: suma,
  torta: torta,
  tortuga: tortuga,
  queque: queque,
  rosa: rosa,
  duende: duende,
  maleta: maleta,
  nota: nota,
  pasto: pasto,
  patines: patines,
  pato: pato,
  pelota: pelota,
  pepino: pepino,
  pino: pino,
  tapa: tapa,
  tomate: tomate,
  topo: topo,
  tuna: tuna,
  abeja: abeja,
  araña: araña,
  ardilla: ardilla,
  calcetín: calcetín,
  camión: camión,
  camisa: camisa,
  caracol: caracol,
  casa: casa,
  corbata: corbata,
  estrella: estrella,
  gato: gato,
};

const defaultStyles = {
  overflow: "hidden",
  position: "absolute",
  color: "black",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // fontSize: "2em",
  fontFamily: "'Kanit', sans-serif",
  textTransform: "uppercase",
  cursor: "pointer",
  zIndex: 1000000,
};

export default class Frame extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      frame: this.props.frame,
      position: this.props.id,
      point: 0,
      imageWord: "",
    };
    this.changeValue = this.changeValue.bind(this);
    this.incrementPoint = this.incrementPoint.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  componentDidUpdate() {
    if (isNaN(this.state.frame)) {
      this.setState({ imageWord: dict_words[this.state.frame] });
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.refresh);
  }

  changeValue(value) {
    this.setState({ frame: value });
  }

  incrementPoint() {
    let point = this.state.frame;
    point = point + 1;
    this.setState({ frame: point });
  }

  refresh() {
    if (typeof this.state.frame === "number") {
      let point = this.state.frame;
      point = point + 1;
      this.setState({ frame: point });
      this.setState({ frame: point - 1 });
    } else {
      let currentFrame = this.state.frame;
      this.setState({ frame: "" });
      this.setState({ frame: currentFrame });
    }
  }

  render() {
    let position = "";
    let width = 9.66;
    let height = (window.innerHeight * 17.4) / 100;
    let top = 0;
    if (
      (window.innerWidth > 480) &
      (window.innerWidth / window.innerHeight > 1)
    ) {
      top = "71.4%";
      position = "33.55%";
      if (this.props.id === 1) {
        position = "45.15%";
      } else if (this.props.id === 2) {
        position = "56.8%";
      } else if (this.props.id === 4) {
        width = 8.35;
        height = (window.innerHeight * 15) / 100;
        position = "72.35%";
        top = "3.9%";
      }
    } else {
      width = 24.5;
      height = (window.innerHeight * 13.5) / 100;
      top = "78.5%";
      position = "9.5%";
      if (this.props.id === 1) {
        position = "37.8%";
      } else if (this.props.id === 2) {
        position = "66.6%";
      } else if (this.props.id === 4) {
        position = "71.9%";
        width = 24.7;
        height = (window.innerHeight * 13.8) / 100;
        top = "3.50%";
      }
    }
    return (
      <Transition
        items={this.state.frame}
        // initial={null}
        from={{
          overflow: "hidden",
          height: height,
          opacity: 1,
          background: "white",
        }}
        enter={{
          width: width + "%",
          height: height,
          opacity: 1,
          borderRadius: "50%",
          border: "3px solid black",
        }}
        leave={{
          height: height,
          opacity: 1,
          display: "none",
        }}
        trail={200}
      >
        {(item) => (styles) => (
          <animated.div
            style={{ ...defaultStyles, ...styles, left: position, top: top }}
          >
            {this.state.imageWord !== "" ? (
              <div>
                <img
                  src={this.state.imageWord}
                  className="words-image"
                  alt="background"
                />
              </div>
            ) : (
              <div>
                <strong style={{ fontSize: "32px" }}>{item}</strong>
              </div>
            )}
          </animated.div>
        )}
      </Transition>
    );
  }
}
